import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { IUser } from "modules/app/types";

export type OnlineUsers = Record<string, IUser>;
type InitialState = {
  connected: boolean;
  onlineUserCount: number;
  onlineUsers: OnlineUsers;
};

export const initialState: InitialState = {
  connected: true,
  onlineUserCount: 0,
  onlineUsers: {},
};

const onlinePresenceSlice = createSlice({
  initialState,
  name: "onlinePresence",
  reducers: {
    setConnected: (state, action: PayloadAction<boolean>) => {
      state.connected = action.payload;
    },
    addUser: (state, action: PayloadAction<IUser>) => {
      const { payload: user } = action;

      if (state.onlineUsers[user.id]) {
        return;
      }
      state.onlineUsers = { ...state.onlineUsers, [user.id]: user };
      state.onlineUserCount += 1;
    },
    removeUser: (state, action: PayloadAction<string>) => {
      const { payload: userId } = action;

      const { [userId]: _userToRemove, ...onlineUsers } = state.onlineUsers;

      state.onlineUsers = onlineUsers;

      state.onlineUserCount -= 1;
    },
    reset: () => initialState,
  },
});

export const { setConnected, addUser, removeUser, reset } =
  onlinePresenceSlice.actions;

export default onlinePresenceSlice.reducer;
